import { render } from "./MobileApp.vue?vue&type=template&id=5bc2eb49"
import script from "./MobileApp.vue?vue&type=script&lang=js"
export * from "./MobileApp.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__